import Spline from "@splinetool/react-spline";
import { BsArrowLeft } from "react-icons/bs";
import "../../App.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Rooms() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(1);
  const increment = 1;

  const handleData = () => {
    // Simulate loading progress
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        const newProgress = prevProgress + increment;
        if (newProgress >= 100) {
          clearInterval(interval);
          setLoading(false);
          return 100;
        }
        return newProgress;
      });
    }, 50);

    setTimeout(() => {
      clearInterval(interval);
      setLoading(false);
    }, 5000);
  };

  useEffect(() => {
    console.log("Loading state has changed:", loading);
  }, [loading]);

  return (
    <div>
      <div className={`loadingHome ${loading ? "show" : "hide"}`}>
        <div
          style={{ height: "100%", position: "relative", overflow: "hidden" }}
          className="d-flex justify-content-center align-items-center"
        >
          <p className="text-center">Loading {progress}%</p>{" "}
        </div>
      </div>
      <div className="section d-flex flex-column justify-content-center">
        <br />

        <div className="container " style={{ position: "relative" }}>
          <button
            onClick={() => navigate(-1)}
            className="btn btn-sm btn-light"
            style={{ position: "absolute", top: "10px" }}
          >
            <BsArrowLeft size={20} />
          </button>
          <br />
          <br />
          <h1 className="text-center">Explore My 3D Room</h1>
          <p className="text-center mx-2">
            This room was created using the Three JS JavaScript framework, and
            using Blender software
          </p>
          <br />
          <div>
            <Spline
              style={{ height: "80vh" }}
              scene="https://prod.spline.design/de4N5a6pso9zDXFy/scene.splinecode"
              onLoad={handleData}
            />
            <div className="btn-scroll d-flex justify-content-center align-items-center">
              <p className="mb-0">Hold to Scroll Page</p>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  );
}
